import Vue from 'vue';
import vuetify from '../plugins/vuetify';
import App from './ConvocationApp.vue';
import router from './routes/index';
import axios from 'axios';
import urlUtil from '@/utils/urlUtil';
import NotificationPlugin from '../plugins/notify';

axios.defaults.baseURL = urlUtil.getBaseUrl();

Vue.config.productionTip = false;
Vue.use(NotificationPlugin);

new Vue({
  vuetify,
  router,
  render: (h) => h(App),
}).$mount('#app');
